import { API_URL } from "../config";

class API {
  constructor() {
    if (!API_URL) throw new Error("API_URL must be specified in .env");
    this.baseUrl = API_URL;
    this.headers = {
      "Content-Type": "application/json",
    };
  }

  async post(endpoint, data, options = {}) {
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: "POST",
      headers: {
        ...this.headers,
        ...options.headers,
      },
      body: JSON.stringify(data),
      credentials: "include",
    });
    if (response.status === 401) window.location = "/signin";
    return await response.json();
  }

  async postFormData(endpoint, data, options = {}) {
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: "POST",
      headers: {
        ...this.headers,
        ...options.headers,
        "Content-Type": "multipart/form-data",
      },
      body: data,
      credentials: "include",
    });
    if (response.status === 401) window.location = "/signin";
    return await response.json();
  }

  async get(endpoint, options = {}) {
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: "GET",
      headers: {
        ...this.headers,
        ...options.headers,
      },
      credentials: "include",
    });
    if (response.status === 401) window.location = "/signin";
    return await response.json();
  }

  async put(endpoint, data, options = {}) {
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: "PUT",
      headers: {
        ...this.headers,
        ...options.headers,
      },
      body: JSON.stringify(data),
      credentials: "include",
    });
    if (response.status === 401) window.location = "/signin";
    return await response.json();
  }

  async delete(endpoint, options = {}) {
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: "DELETE",
      headers: {
        ...this.headers,
        ...options.headers,
      },
      credentials: "include",
    });
    if (response.status === 401) window.location = "/signin";
    return await response.json();
  }
}

const api = new API();
export default api;
